var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',[_c('message',{attrs:{"message":_vm.message.message}}),_vm._l((_vm.message.children),function(child){return _c('div',{key:child.message.messageId},[_c('message',{attrs:{"message":child.message}})],1)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }